var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "aedw-package-buttons" },
        [
          _vm._l(_vm.categories, function(item, key) {
            return [
              _c(
                "button",
                {
                  key: key,
                  staticClass: "m-1 btn",
                  class: {
                    "btn-primary": _vm.isSelected(item),
                    "btn-outline-primary": !_vm.isSelected(item)
                  },
                  on: {
                    click: function($event) {
                      return _vm.onSelect(item)
                    }
                  }
                },
                [_vm._v(_vm._s(item.tagline || item.name))]
              )
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("PackageList", {
        attrs: {
          useCustomTemplate: _vm.useCustomTemplate,
          templateName: _vm.templateName,
          params: _vm.mergedParams,
          config: _vm.config,
          useDefaultGridCols: _vm.useDefaultGridCols,
          disableGetPackagesOnRender: _vm.disableGetPackagesOnRender,
          show_in_carroussel_mobile: _vm.show_in_carroussel_mobile,
          show_in_carroussel_desktop: _vm.show_in_carroussel_desktop,
          titleWidget: _vm.titleWidget,
          use_location_unit_selector: _vm.use_location_unit_selector,
          location_unit_selector_params: _vm.location_unit_selector_params,
          use_multi_widgets: _vm.use_multi_widgets,
          multi_widgets_params: _vm.multi_widgets_params,
          paramsFilterRequestPOS: _vm.paramsFilterRequestPOS
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }